const fontBase = 18; // px

// For calculations (returns number)
export const pxToRemNum = (px) => px / fontBase;

// For CSS values (returns string with "rem")
export const pxToRem = (px) => `${px / fontBase}rem`;
